<script>
  import RouteStatus from "./views/RouteStatus.svelte";
  import RouteMap from "./views/RouteMap.svelte";
  import { googleMapsReady } from "./store.js";
  import { onMount, onDestroy } from "svelte";
  import { rdyRideAPI as api } from "./api.js";
  i; // import { stops, stopArrivalTimes, mapVehiclePoints } from './store.js';

  export let domain;
  export let routeIDs;
  export let views;
  export let ready;

  $: $googleMapsReady = ready;

  let i = 0;
  let targetElement = "";
  let element = null;
  let componentToShow = [];
  let routeMapIDs = views.reduce((acc, view) => {
    if (view === "route_map") acc.push(routeIDs[i]);
    i++;
    return acc;
  }, []);
  let routeMapCount = views.reduce((acc, view) => {
    if (view === "route_map") acc++;
    return acc;
  }, 0);
  let onlyMap = routeMapCount === 1;
  let firstMapOnPage = routeMapIDs[0];
  i = 0;
  views.forEach(view => {
    targetElement = ".rdy-ride-" + view + "-" + routeIDs[i];
    element = document.querySelector(targetElement);
    switch (views[i]) {
      case "route_status":
        componentToShow[i] = new RouteStatus({
          target: element,
          props: {
            routeId: routeIDs[i]
          }
        });
        break;
      case "route_map":
        componentToShow[i] = new RouteMap({
          target: element,
          props: {
            routeId: routeIDs[i],
            onlyMap: onlyMap,
            routeMapIDs: routeMapIDs,
            firstMapOnPage: firstMapOnPage === routeIDs[i]
          }
        });
        break;
    }
    i++;
  });

  onMount(() => {
    api.domain = domain;

    // determine if we need to fetch all routes or 1 specific route
    let uniqueRouteIDs = [...new Set(routeIDs)];
    if (uniqueRouteIDs.length > 1) {
      api.routeId = null;
    } else {
      //api.routeId = routeIDs[0];
      // pull data for all routes anyways
      api.routeId = null;
    }

    // load data for any view that will be displayed
    if (views.includes("route_status") || views.includes("route_map")) {
      api.mapVehiclePoints();
      api.routesForMapWithScheduleWithEncodedLine();
    }
    if (views.includes("route_status")) {
      api.stops();
      api.stopArrivalTimes();
    }

    // set a 30 data update timer for any view that will be displayed
    const interval = setInterval(() => {
      // (1) Route Status Data
      if (views.includes("route_status")) {
        api.mapVehiclePoints();
        api.stops();
        api.stopArrivalTimes();
      }
    }, 30000);

    return () => {
      clearInterval(interval);
    };
    onDestroy(() => clearInterval(interval));
  });
</script>
